import { ResponseStatus } from '../../resources/@types/accountSchema';

/**
 * setQueryData할 때 공통으로 사용하는 타입(statusCode, message)을 처리하는 함수
 */
export const setQueryDataUpdater = <T>(
  data: T,
): {
  statusCode: ResponseStatus;
  message: string;
  data: T;
} => ({
  statusCode: ResponseStatus.OK,
  message: '',
  data,
});
